import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import cn from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  className?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { error, className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      {...props}
      className={cn(
        "w-full rounded-[12px] border border-[#EBEDF2] px-4 py-4 text-[13px] text-[#111827] transition-colors duration-150 outline-none",
        "placeholder:text-[#11182780]",
        "focus:border-[#111827]",
        error && "border-[#E02800] focus:border-[#E02800]",
        className,
      )}
    />
  );
});
